import { getRelativeTimeStampRange } from 'app/shared/utils/date';
import { useTransactionalService } from 'hooks/transactional';
import { useMailLogService } from 'hooks/maillog';
import { useMailActionService } from 'hooks/mailaction';
import React, { useEffect, useState } from 'react';
import { SlidingStatBar } from 'app/layouts/stats/sliding';
import { RelativeStatCard } from 'app/shared/cards/stat/relative';

export const TransactionalStatBar = () => {
  const { fetchTransactionals } = useTransactionalService();
  const { fetchMailLogs } = useMailLogService();
  const { fetchMailActions } = useMailActionService();

  const [stats, setStats] = useState([
    {
      label: 'Total Transactionals',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Emails Sent',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Emails Opens',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Link Clicks',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    }
  ]);

  useEffect(() => {
    const { this_month, last_month } = getRelativeTimeStampRange();
    Promise.all([
      fetchTransactionals({ query_string: `count=1` }),
      fetchTransactionals({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&count=1`
      }),
      fetchTransactionals({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&count=1`
      }),
      fetchMailLogs({ query_string: `class=transactional&count=1` }),
      fetchMailLogs({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&class=transactional&count=1`
      }),
      fetchMailLogs({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&class=transactional&count=1`
      }),
      fetchMailActions({ query_string: `resource_type=transactional&action=opened&count=1` }),
      fetchMailActions({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&resource_type=transactional&action=opened&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&resource_type=transactional&action=opened&count=1`
      }),
      fetchMailActions({ query_string: `resource_type=transactional&action=clicked_link&count=1` }),
      fetchMailActions({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&resource_type=transactional&action=clicked_link&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&resource_type=transactional&action=clicked_link&count=1`
      })
    ]).then(
      ([
        { size: transactional_all_time },
        { size: transactional_this_month },
        { size: transactional_last_month },
        { size: emails_all_time },
        { size: emails_this_month },
        { size: emails_last_month },
        { size: email_opens_all_time },
        { size: email_opens_this_month },
        { size: email_opens_last_month },
        { size: link_clicks_all_time },
        { size: link_clicks_this_month },
        { size: link_clicks_last_month }
      ]) => {
        setStats([
          {
            label: 'Total Transactionals',
            main_value: transactional_all_time,
            current_value: transactional_this_month,
            previous_value: transactional_last_month
          },
          {
            label: 'Total Emails Sent',
            main_value: emails_all_time,
            current_value: emails_this_month,
            previous_value: emails_last_month
          },
          {
            label: 'Total Emails Opens',
            main_value: email_opens_all_time,
            current_value: email_opens_this_month,
            previous_value: email_opens_last_month
          },
          {
            label: 'Total Link Clicks',
            main_value: link_clicks_all_time,
            current_value: link_clicks_this_month,
            previous_value: link_clicks_last_month
          }
        ]);
      }
    );
  }, []);

  return (
    <>
      <SlidingStatBar>
        {stats.map((stat, index) => (
          <RelativeStatCard
            key={index}
            title={stat.label}
            main_value={stat.main_value}
            current_value={stat.current_value}
            previous_value={stat.previous_value}
            period="month"
          />
        ))}
      </SlidingStatBar>
    </>
  );
};
